// extracted by mini-css-extract-plugin
export default {"confirmIcon":"UnconfirmedStopsTable_confirmIcon__ucAGn","confirmWrapper":"UnconfirmedStopsTable_confirmWrapper__g-lMN"};